import axiosInstance from '../../../../core/api/axios';
import { axiosInstancePlano } from '../../../../core/api/planoAxios';
import { ILesson } from '../../../../core/models/disciplines';
import { useUserStore } from '../../../Auth/stores/authStore';
import { useUserEssay } from '../../../Essay/hooks/useUserEssay';
import { IPAContent } from '../../model/dailySchedule';

export async function getLessonDetails(slug: string): Promise<ILesson> {
  try {
    const response = await axiosInstance.get(`/lessons/${slug}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getContentListByDay(
  cronogramaId: string,
  module: string,
  day: string
): Promise<IPAContent[]> {
  try {
    const response = await axiosInstancePlano.get(
      `/cronograma/${cronogramaId}/conteudo/dia`,
      {
        params: {
          module,
          dia: day,
        },
      }
    );

    if (response.data) {
      // Preserva o estado "respondido" que veio do endpoint (done) antes de
      // qualquer mutação local — ao responder, o done é setado como true no
      // store, o que apagaria a informação de "já respondido anteriormente".
      response.data = response.data.map((it: any) => ({
        ...it,
        content: { ...it.content, answeredOnServer: !!it.content?.done },
      }));

      try {
        const contentIds = response.data.map((it: any) => it.content.id);
        const reviews = await getContentListReviews(contentIds);

        const responseData = response.data.map((it: any) => {
          const reviewE:any = reviews.find((r: any) => r.contentId === it.content.id)
          const favoriteE: any = reviews.find((j: any) => j.contentId === it.content.id)

          const _review = reviewE ? reviewE.review : null;
          const _favorite = favoriteE ? favoriteE.favorite : false;

          const data = {
            ...it,
            content: {
              ...it.content,
              review: _review,
              favorite: _favorite,
            },
          };

          return data;
        });

        return responseData;
      } catch (err) {
        console.log(err);
        console.error('Error fetching reviews');
      }
    }

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getContentListReviews(
  contentIds: any
): Promise<IPAContent[]> {
  try {
    const response = await axiosInstance.post(
      `/plano-adaptativo/review-and-favorites`,
      { contentIds: contentIds }
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export interface IPAContentEventParams {
  contentId: string;
  cronogramaId: string;
}

export async function onFavoritePAContent(params: IPAContentEventParams) {
  const response = await axiosInstancePlano.post(
    `/cronograma/${params.cronogramaId}/favoritar`,
    {
      conteudosIds: [params.contentId],
    }
  );

  return response.data;
}

export async function onDonePAContent(params: IPAContentEventParams) {
  const response = await axiosInstancePlano.post(
    `/cronograma/${params.cronogramaId}/concluir`,
    {
      idCronograma: params.cronogramaId,
      conteudosIds: [params.contentId],
    }
  );

  return response.data;
}

export async function onDonePAMaterial(params: IPAContentEventParams) {
  const response = await axiosInstancePlano.post(
    `/cronograma/${params.cronogramaId}/material/${params.contentId}/concluir`
  );

  return response.data;
}

export async function answerExercise(
  cronogramaId: string,
  exerciseId: string,
  alternativeId: string[]
) {
  const response = await axiosInstancePlano.post(
    `/cronograma/${cronogramaId}/exercicio/${exerciseId}/concluir`,
    {
      respostas: alternativeId,
    }
  );
  return response.data;
}

export async function getExerciseAnswer(
  cronogramaId: string,
  exerciseId: string
) {
  const response = await axiosInstancePlano.get(
    `/cronograma/${cronogramaId}/exercicio/${exerciseId}/respostas`
  );

  return response.data;
}

export const deleteSubjectFromDay = async (cronogramaId: string, subjectIds: string[], date: string) => {
  try {
    const user = useUserStore.getState().user;
    if(!user) throw new Error('Usuário não encontrado');

    const body = { subjectIds, day: date, userId: user.id }

    const { data } = await axiosInstancePlano.patch(`/management/exclude-day-subject/${cronogramaId}`, body);
  
    return data;
  } catch (error: any) {
    throw error.response.data;
  }
}